import type { HTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';

export type CardVariant = 'panel' | 'hairline' | 'hero';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: CardVariant;
  children: ReactNode;
}

const variantClasses: Record<CardVariant, string> = {
  panel: 'bg-panel border border-hairline rounded-md p-6 shadow-panel',
  hairline: 'bg-panel border border-hairline rounded-md p-6',
  hero: 'bg-panel border border-hairline rounded-md p-10 md:p-14 shadow-panel',
};

export function Card({ variant = 'panel', className, children, ...rest }: CardProps) {
  return (
    <div className={clsx(variantClasses[variant], className)} {...rest}>
      {children}
    </div>
  );
}
